var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8429 0.683945L12.8431 0.683726L12.8361 0.676655C12.5933 0.433851 12.222 0.433823 11.9791 0.676573C11.9791 0.676601 11.9791 0.676628 11.9791 0.676655L6.85718 5.77596L1.75787 0.676655C1.51504 0.433823 1.14369 0.433823 0.900858 0.676655C0.658027 0.919486 0.658027 1.29084 0.900858 1.53367L1.00692 1.4276L0.900858 1.53367L5.99993 6.63274L0.877827 11.7548C0.634995 11.9977 0.634995 12.369 0.877827 12.6119C1.12066 12.8547 1.49201 12.8547 1.73484 12.6119L6.83392 7.51279L11.933 12.6119C12.1758 12.8547 12.5472 12.8547 12.79 12.6119C13.0328 12.369 13.0328 11.9977 12.79 11.7548L7.69093 6.65578L12.7871 1.55961C13.0556 1.31757 13.0546 0.925933 12.8429 0.683945Z",
    fill: "#232323",
    stroke: "#232323",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseblack);
export default __webpack_public_path__ + "static/media/closeblack.f90839ed3b4dacece0142ba80427faf4.svg";
export { ForwardRef as ReactComponent };